<div class="dashboard-heading">
  <h1>{{ 'ADMIN_PANEL_NOTIFICATION_TEMPLATES' | translate }}</h1>
</div>

<dx-data-grid
  class="datagrid-admin mb-5"
  [dataSource]="notificationTemplates$ | async"
  [showBorders]="true"
  [allowColumnResizing]="true"
  [masterDetail]="{ enabled: true, template: 'details' }"
  [hoverStateEnabled]="true"
  [columnMinWidth]="70"
  [columnAutoWidth]="true"
  keyExpr="id"
  stylingMode="outlined"
  rowTemplate="rowTemplate"
  noDataText="{{ 'DATA_NOT_FOUND' | translate }}"
  (onRowClick)="rowClick($event)">
  <!--<dxo-group-panel [visible]="true"></dxo-group-panel>-->
  <!--<dxo-grouping [autoExpandAll]="true"></dxo-grouping>-->

  <dxo-selection mode="single"></dxo-selection>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column dataField="id" caption="{{ 'NOTIFICATION_TEMPLATES_ID' | translate }}" [width]="70"></dxi-column>
  <dxi-column dataField="name" caption="{{ 'NOTIFICATION_TEMPLATES_NAME' | translate }}"></dxi-column>
  <dxi-column dataField="subject" caption="{{ 'NOTIFICATION_TEMPLATES_TITLE' | translate }}"></dxi-column>
  <dxi-column dataField="notes" caption="{{ 'NOTIFICATION_TEMPLATES_DESCRIPTION' | translate }}"></dxi-column>
  <dxi-column dataField="subsystem.value" caption="{{ 'NOTIFICATION_TEMPLATES_TYPE' | translate }}" [width]="150"></dxi-column>

  <tbody class="dx-row" *dxTemplate="let entity of 'rowTemplate'">
    <tr class="main-row">
      <td>
        @if (entity.isExpanded) {
          <span><i class="mdi mdi-minus mdi-18px"></i></span>
        }
        @if (!entity.isExpanded) {
          <span><i class="mdi mdi-plus mdi-18px"></i></span>
        }
      </td>
      <td>
        {{ entity.data.id }}
      </td>
      <td>
        {{ entity.data.name }}
      </td>
      <td>
        {{ entity.data.subject }}
      </td>
      <td>
        {{ entity.data.notes }}
      </td>
      <td>
        {{ entity.data.subsystem.value }}
      </td>
    </tr>
  </tbody>

  <div *dxTemplate="let entity of 'details'">
    <app-notification-template-details
      [notificationTemplate]="entity.data"
      (onSave)="this.onSave($event)"></app-notification-template-details>
  </div>

  <dxo-paging [pageSize]="15"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[15, 50, 100, 1000]"></dxo-pager>
</dx-data-grid>
